import { Box, Typography } from '@coolblue-development/becky';
import { CrossCircled } from '@coolblue-development/icons';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { formatAbsoluteTime } from '../../../../../utils/formatAbsoluteTime';

interface ChatMessageProps {
  chatMessage: connect.ChatEventData;
}

const CUSTOMER_LEFT_CONTENT_TYPE = 'application/vnd.amazonaws.connect.event.participant.left';

const ChatMessage: React.FC<ChatMessageProps> = ({ chatMessage }): JSX.Element | null => {
  const { Content: message, ContentType: contentType, ParticipantRole: role, AbsoluteTime } = chatMessage;
  const isAgent = role !== 'CUSTOMER';

  if (role === 'CUSTOMER' && contentType === CUSTOMER_LEFT_CONTENT_TYPE) {
    return (
      <Box
        data-testid="customer-disconnected-indicator"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          marginTop: '10px',
          color: '#666'
        }}
      >
        <CrossCircled size={20} color="#6C6E75" />
        <Typography fontSize={13} color="#6C6E75">
          The customer was disconnected
        </Typography>
      </Box>
    );
  }

  const bubbleStyle = {
    width: 'fit-content',
    background: isAgent ? '#CCE9F9' : '#FFF',
    boxShadow: '0px 1px 2px 0px #285DAB33',
    border: isAgent ? 'none' : '1px solid #DDDDDD',
    borderRadius: '5px',
    padding: '15px',
    marginLeft: isAgent ? 'auto' : '',
    maxWidth: '60%'
  };

  const localTime = formatAbsoluteTime(AbsoluteTime);

  return message ? (
    <Box sx={{ marginTop: '10px', textAlign: isAgent ? 'right' : 'left' }} data-testid="chat-message">
      <Box
        style={bubbleStyle}
        sx={{ textAlign: 'left', wordBreak: 'break-word' }}
        data-testid={isAgent ? 'agent-bubble' : 'customer-bubble'}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            p: ({ children }) => <p style={{ margin: 0 }}>{children}</p>,
            a: ({ ...props }) => <a {...props} target="_blank" />
          }}
        >
          {message}
        </ReactMarkdown>
      </Box>
      <Typography fontSize={11} color={'#999'}>
        {localTime}
      </Typography>
    </Box>
  ) : null;
};

export default ChatMessage;
